// extracted by mini-css-extract-plugin
export var closeButton = "VideoPlayer-module--closeButton--5158e";
export var closeButtonWrapper = "VideoPlayer-module--closeButtonWrapper--b7fb3";
export var modalContent = "VideoPlayer-module--modalContent--314a6";
export var modalPlayerWrapper = "VideoPlayer-module--modalPlayerWrapper--cda37";
export var video = "VideoPlayer-module--video--c0cfa";
export var videoplayer = "VideoPlayer-module--videoplayer--07d47";
export var wrapper = "VideoPlayer-module--wrapper--6ff23";